export default __webpack_public_path__ + "static/FarizaRevuelta-cc75731ee62b570632802ecd4f9a6b94.png";